import request from '../utils/request';
const baseUrl = 'http://dev.hwason.com/orderadmin';


//订单明细查询接口
export const getOrderListSon = query => {
	return request({
		url: baseUrl + '/orderMaster/list',
		method: 'post',
		data: query
	});
};
//查看订单明细 表格展开事件查询接口
export const findItemInfoSon = query => {
	return request({
		url: baseUrl + '/orderMaster/findOne',
		method: 'post',
		data: query
	});
};

// 上传图片接口
export const uploadImage = query => {
	return request({
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		url: '/bmultiUpload',
		method: 'post',
		data: query
	});
};